
<template>
    <div class="dropzone" v-on="handlers">

        <p v-if="uploaded">{{ uploaded }} files uploaded.</p>

        <p v-if="queue.length">{{ queue.length }} files waiting.</p>
        <input ref="input" type="file" name="files[]" :multiple="batch > 1" :accept="accept" :capture="capture" v-on:change="changed"/>


        <ul>
            <li v-for="upload in uploading">
                <a v-on:click="upload.cancel">Cancel</a>

                file name
                file size
                <div class="bar">
                    <div class="progress" :style="`width:${upload.progress}%`"></div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import auth from '../support/Auth';

    function getMetaContent(metaName) {
        var metas = document.getElementsByTagName('meta');
        var re = new RegExp('\\b' + metaName + '\\b', 'i');
        var i = 0;
        var mLength = metas.length;

        for (i; i < mLength; i++) {
            if (re.test(metas[i].getAttribute('name'))) {
                return metas[i].getAttribute('content');
            }
        }

        return '';
    }

    window.csrf = getMetaContent( 'csrf-token' );



    class Upload
    {
        constructor( endpoint, files, callback )
        {
            this.endpoint = endpoint;
            this.files = files;
            this.progress = 0;
            this.request = null;
            this.done = false;
            this.callback = callback;
            // this.size = file.size;
            this.cancel = this.cancel.bind( this );
        }


        send()
        {
            const data = new FormData();
            data.set( '_token', window.csrf );
            for( let i = 0, length = this.files.length; i !== length; ++i )
                data.append( 'photos[]', this.files[i], this.files[i].fullPath );

            this.request = new XMLHttpRequest();
            this.request.onload = event => {
                this._finished();
                this.callback();
            };

            const upload = this.request.upload !== null ? this.request.upload : this.request;
            upload.onprogress = event => this.progress = 100 * event.loaded / event.total;

            this.request.open( 'post', this.endpoint );
            this.request.send( data );
            return this;
        }


        cancel()
        {
            this.request.abort();
        }

        _finished()
        {
            this.request = null;
            this.done = true;
        }
    }

    export default
    {
        props:
        {
            endpoint: {
                type: String,
                required: true,
            },
            accept: {
                type: String,
                default: null,
            },
            capture: {
                type: Boolean,
                default: true,
            },
            batch: {
                type: Number,
                default: 1,
            },
            parallel: {
                type: Number,
                default: 4,
            },
        },
        data()
        {
            window.v = this;
            return {
                handlers:
                {
                    dragleave: this.disable,
                    dragenter: this.disable,
                    dragover: this.disable,
                    drop: this.drop,
                },


                uploads: [],

                queue: [],


                uploaded: 0,
                uploading: [],
            }
        },
        methods:
        {
            disable( event )
            {
                event.preventDefault();
                event.stopPropagation();
            },
            changed()
            {
                // todo: perhaps better to provide an upload button?
                this.enqueue( this.$refs.input.files );
            },
            size(size) {
                var units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                var i = 0;
                while(size >= 1024) {
                    size /= 1024;
                    ++i;
                }
                return size.toFixed(2) + ' ' + units[i];
            },
            drop( event )
            {
                this.disable( event );

                if( ! event.dataTransfer )
                    return;

                const files = [];
                for( let i = 0, length = event.dataTransfer.files.length; i !== length; ++i )
                    files.push( event.dataTransfer.files[i] )

                if( ! files.length )
                    return;

                const items = event.dataTransfer.items;
                if( items && items.length && items[0].webkitGetAsEntry !== null ) {
                    this.scan( items ).then( this.enqueue );
                } else this.enqueue( files );
            },
            scan( items )
            {



                function handle( entry )
                {
                    if( entry.isFile ) {
                        return new Promise( ( resolve, reject ) => {
                            entry.file( resolve, reject );
                        });

                        //return entry;
                    } else return traverse( entry );
                }


                function traverse( entry, path )
                {
                    const reader = entry.createReader();

                    return new Promise( ( resolve, reject ) => {
                        const files = [];

                        function read()
                        {
                            reader.readEntries( entries => {
                                if( ! entries.length ) {
                                    resolve(
                                        Promise.all( files ).then( entries => {
                                            return [].concat( ...entries );
                                        })
                                    );
                                } else {
                                    const response = Promise.all( entries.map( handle ) );

                                    files.push( response );
                                    read();
                                }
                            }, reject );
                        }

                        read();
                    });
                }

                return Promise.all(
                    [ ...items ].map( entry => {
                        entry = entry.webkitGetAsEntry();
                        return handle( entry );
                    })
                ).then( entries => [].concat( ...entries ) );

            },
            enqueue( files )
            {
                this.queue.push( ...files );
                this.process();
            },
            process()
            {
                if( ! this.queue.length || this.uploading.length >= this.parallel )
                    return;

                for( let i = 0, length = this.parallel - this.uploading.length; i !== length; ++i ) {
                    const files = this.queue.splice( 0, this.batch );
                    if( ! files.length )
                        break;

                    this.upload( files );
                }
            },
            upload( files )
            {
                function callback()
                {
                    this.uploaded += 1;
                    this.uploading = this.uploading.filter( request => {
                        return ! request.done;
                    });
                    this.process();
                }

                const request = new Upload( this.endpoint + '?api_token=' + auth.token, files, callback.bind(this) ).send();
                this.uploading.push( request );
            }
        },
    }
</script>

<style scoped>

    .dropzone {
        width: 100%;
        height: 200px;
        border: 2px solid aquamarine;
    }

    .bar { width: 300px; height: 2px; background: #eee }
    .progress { height: 2px; background: darkturquoise }

</style>
